import React, { useRef } from 'react';
import { useToast } from '../../ToastProvider';
import copy from 'copy-to-clipboard';
interface SustainabilityElementProps {
    name: string;
    value: string;
}

export function SustainabilityElement({ name, value }: SustainabilityElementProps) {
    const nameRef = useRef<HTMLDivElement>(null);
    const valueRef = useRef<HTMLDivElement>(null);

    const { showToast } = useToast();
    const isOverflowing = (element: HTMLDivElement | null): boolean => {
        return element ? element.scrollWidth > element.clientWidth : false;
    };

    const handleOverflowClick = (ref: React.RefObject<HTMLDivElement>, content: string) => {
        copy(content, {
            debug: false,
            message: 'Press #{key} to copy',
        });
        showToast({ title: 'Copied to clipboard', intent: 'success', body: content });
    };

    const normalizedValue = value.replace(',', '.');
    const isNumeric = /^[+-]?\d+(\.\d+)?$/.test(normalizedValue);

    const roundedValue = isNumeric
        ? Number.isInteger(parseFloat(normalizedValue))
            ? normalizedValue
            : parseFloat(normalizedValue).toFixed(3)
        : value;

    return (
        <div className="flex justify-between items-center gap-2 py-2 rounded-lg">
            <div
                ref={nameRef}
                className="font-bold overflow-hidden whitespace-nowrap text-ellipsis cursor-pointer"
                title={name}
                onClick={() => handleOverflowClick(nameRef, name + ": " + roundedValue)}
            >
                {name}
            </div>

            <div
                ref={valueRef}
                className="overflow-hidden whitespace-nowrap text-ellipsis cursor-pointer text-right"
                title={roundedValue}
                onClick={() => handleOverflowClick(nameRef, name + ": " + roundedValue)}
            >
                {roundedValue}
            </div>
        </div>
    );
}
